import { Box, Flex, Text } from "@chakra-ui/react";
import { LinkText } from "../LinkText";
import { store, useStoreData } from "../../../lib/store/store";
import { ActionType } from "../../../lib/store/storeActions";

interface HeaderProps {
  loggedIn: boolean;
  onSignInClick: () => void;
  /** When set, renders as the step's title on the left, with the
   *  greeting / log-out cluster pushed to the right. */
  title?: React.ReactNode;
}

export const Header = ({ loggedIn, onSignInClick, title }: HeaderProps) => {
  const storeData = useStoreData();

  if (loggedIn) {
    const firstName = storeData.user?.first_name;
    return (
      <Flex
        justify={title || firstName ? "space-between" : "flex-end"}
        align="center"
        w="100%"
        px="20px"
        gap="12px"
      >
        {title ? (
          <Text
            as="h2"
            m="0"
            fontFamily="body"
            fontSize="22px"
            fontWeight="semibold"
            color="fg.default"
            letterSpacing="-0.015em"
            lineHeight="1.2"
          >
            {title}
          </Text>
        ) : (
          firstName && (
            <Text fontFamily="body" fontWeight="bold" color="fg.muted" m="0">
              Hi, {firstName}!
            </Text>
          )
        )}
        <Box
          fontFamily="body"
          fontSize="12px"
          color="fg.muted"
          flexShrink={0}
        >
          {/* When the title is taking the left slot, drop "Hi, X!" /
              "Not X?" — it's redundant against a step heading. Just
              show the log-out affordance. */}
          {!title && firstName && <>Not {firstName}?&nbsp;</>}
          <LinkText
            fontSize="12px"
            onClick={() =>
              store.dispatch({ type: ActionType.LogOut, params: {} })
            }
          >
            Log out
          </LinkText>
        </Box>
      </Flex>
    );
  }

  return (
    <Box px="20px" fontFamily="body" fontSize="14px" color="fg.default">
      Already have an account?&nbsp;
      <LinkText onClick={onSignInClick}>Sign in</LinkText>
    </Box>
  );
};
